import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { themeColor } from '@hud/web-components/theme/colors';

const Container = styled.div`
  display: flex;
  gap: 4px;
`;

const StyledLink = styled(Link)`
  margin-left: 30px;
  font-size: 13px;
  color: ${themeColor('textPrimary')};
  text-decoration: underline;
`;

export { Container, StyledLink };
